import { $myFetch } from "."
import { toastr } from "react-redux-toastr"
import { stringify } from "../../utils/stringifyier"

export const $getMaintenanceState = () => {
  const myHeaders = new Headers()
  return $myFetch(`maintenance/GetMaintenanceState`, {
    headers: myHeaders,
  }).then((res) => res.json())
}

export const $activateMaintenance = () =>
  $setMaintenanceState(true).then((res) => {
    if (res.status === 200) {
      toastr.success(
        "Opération réussie",
        "eSesame est maintenant en maintenance"
      )
    } else {
      toastr.error("Opération échouée", "Un problème est survenu coté serveur")
    }
    return res
  })

export const $deactivateMaintenance = () =>
  $setMaintenanceState(false).then((res) => {
    if (res.status === 200) {
      toastr.success(
        "Opération réussie",
        "eSesame est maintenant en fonctionnement normal"
      )
    } else {
      toastr.error("Opération échouée", "Un problème est survenu coté serveur")
    }
    return res
  })

const $setMaintenanceState = (bool: boolean) => {
  const myHeaders = new Headers()
  myHeaders.append("Content-Type", "application/json")
  return $myFetch(`maintenance/SetMaintenanceState`, {
    headers: myHeaders,
    method: "POST",
    body: stringify({ state: bool }),
  }).then((res) => res.json())
}
